import Router from './components/Router';
import reducers from './reducers';

export default class ModuleConfig {
    static moduleName = 'Wetter';
    static startupComponent = Router;
    static path = '/weather';
    static reducersPrefix = 'weather';
    static reducers = reducers;
}